import { FC, ReactElement } from "react";

import { IPassengerInfo } from "@ryde/shared";

import { FramerTooltip } from "../../tooltips";
import { useRidePassengerTooltipContent } from "./use-ride-passenger-tooltip-content";

interface IRidePassengerTooltipProps {
  passenger: IPassengerInfo;
  companionLabel?: string;
  currentStationId?: number;
  rideSiteId?: number | null;
  rideSiteName?: string;
  children: ReactElement;
  rtlStrippedBottomLeftPlacement?: boolean;
  tooltipDisabled?: boolean;
}

export const RidePassengerTooltip: FC<IRidePassengerTooltipProps> = ({
  passenger,
  companionLabel,
  currentStationId,
  rideSiteId,
  rideSiteName,
  children,
  rtlStrippedBottomLeftPlacement,
  tooltipDisabled,
}) => {
  const { content, handleTooltipOpenChange } = useRidePassengerTooltipContent({
    passenger,
    companionLabel,
    currentStationId,
    rideSiteId,
    rideSiteName,
  });

  if (tooltipDisabled) {
    return <>{children}</>;
  }

  return (
    <FramerTooltip
      content={content}
      onChangeOpen={handleTooltipOpenChange}
      tooltipDisabled={tooltipDisabled}
      rtlStrippedBottomLeftPlacement={rtlStrippedBottomLeftPlacement}
    >
      {children}
    </FramerTooltip>
  );
};
